import { useCallback, useMemo, useState } from "react";

import { Button } from "@/components/ui/button/button";
import { DatePicker } from "@/components/ui/input/date-picker-single";

import * as Model from "../model";

type ChildrenProps = {
	searchDate: string;
};
type Props = {
	children: ({ searchDate }: ChildrenProps) => JSX.Element;
};

export const SearchByDateFormForOptionPms = ({ children }: Props) => {
	const {
		// 検索日
		searchDate,
		//
		// 検索日のセット
		onSetSearchDate,
	} = Model.UseCase.useInitialized();

	const [_searchDate, set_SearchDate] = useState<string>(searchDate ?? "");
	/**
	 * 検索する日付を Query Params にセットする
	 */
	const handleClickSetSearchDate = useCallback(() => {
		onSetSearchDate(_searchDate);
	}, [_searchDate, onSetSearchDate]);

	const disabled = useMemo(() => _searchDate === "", [_searchDate]);

	const RenderChildren = useMemo(() => (searchDate ? children({ searchDate }) : <></>), [children, searchDate]);

	return (
		<>
			<div className="space-y-1">
				<p className="text-sm">オプションPMS / 顧客検索</p>

				<div className="grid grid-cols-1 gap-4 tablet:flex tablet:items-center">
					<DatePicker
						className="w-full tablet:w-80"
						selected={_searchDate}
						canSelectPastDate
						onSelect={set_SearchDate}
					/>

					<Button type="button" size="sm" disabled={disabled} onClick={handleClickSetSearchDate}>
						検索
					</Button>
				</div>
			</div>

			{RenderChildren}
		</>
	);
};
